export const getLearnMoreContent = (
  derivedMemberType: string,
  t: any
): string => {
  switch (derivedMemberType) {
    case "P":
      return t("vaccinations.pet.learn-more-text");
    case "C":
      return t(`vaccinations.child.learn-more-text`);
    default:
      return t("vaccinations.learn-more-text");
  }
};
